export { default } from "./src/confluence-animated-hero";

export type { UniformConfluenceAnimatedHeroProps } from "./src/confluence-animated-hero";
